<script>
import { mapGetters } from 'vuex'
import Filter from './Filter'
import Roles from '@/mixins/Roles'
import Config from '@/utils/metaConfig'
import InputButton from '@/components/input/Button'
import InputSwitch from '@/components/input/Switch'
import Expand from '@/components/elements/Expand'
export default {
    name: 'OrdersList',

    components: { Expand, InputSwitch, InputButton },

    mixins: [Roles],

    data() {
        return {
            selectedServices: { 1: true, 2: false, 3: true, 4: false },
            selectMode: false,
            selectedCards: [],
            perPage: 100,
            selectedSort: {
                key: 'actual_asc',
                label: this.$t('ORDERS.SORT.ACTUAL_DESC'),
            },
            orderSort: [
                {
                    key: 'actual_asc',
                    label: this.$t('ORDERS.SORT.ACTUAL_ASC'),
                },
                {
                    key: 'actual_desc',
                    label: this.$t('ORDERS.SORT.ACTUAL_DESC'),
                },
                {
                    key: 'id_asc',
                    label: this.$t('ORDERS.SORT.ID_ASC'),
                },
                {
                    key: 'id_desc',
                    label: this.$t('ORDERS.SORT.ID_DESC'),
                },
            ],
            exportUrl: `${Config.getApiUrl()}/orders/export`,
        }
    },

    computed: {
        ...mapGetters(['services', 'orders', 'search', 'filters']),

        allSelected() {
            return this.selectedCards.length === this.orders.data.length
        },

        hasSelected() {
            return this.selectedCards.length !== 0
        },

        cardsCollapsed: {
            get() {
                return (
                    this.$store.state.general.cardsCollapsed === true ||
                    this.$store.state.general.cardsCollapsed === 'true'
                )
            },

            set(val) {
                this.$store.dispatch('setCardsCollapsed', val)
            },
        },
    },

    watch: {
        search() {
            this.fetch()
        },
        filters() {
            this.fetch()
        },
        selectedSort() {
            this.fetch()
        },
        perPage() {
            this.fetch()
        },
        selectedServices: {
            handler: 'saveAndFetch',
            deep: true,
        },
        selectMode(val) {
            if (!val) {
                this.selectedCards = []
            }
        },
    },

    mounted() {
        this.$store.dispatch('filterComponent', Filter)
        if (!this.$route.params.page) {
            this.$router.replace({ name: 'home-paged', params: { page: 1 } })
        }
        const services = sessionStorage.getItem('orders-services')
        if (services) {
            try {
                this.selectedServices = JSON.parse(services)
            } catch (e) {
                console.log(e)
            }
        }
        this.fetch()
    },

    methods: {
        fetch(page) {
            page = page || this.$route.params.page
            if (page == undefined || page == null) page = 1
            if (
                this.$route.name != 'home-paged' ||
                this.$route.params.page != page
            )
                this.$router.push({
                    name: 'home-paged',
                    params: { page: page },
                })
            this.$store
                .dispatch('ordersFetch', {
                    page: page,
                    search: this.search,
                    per_page: this.perPage,
                    services: this.selectedServices,
                    filters: this.filters,
                    ids: this.$route.query.ids || null,
                    sort: this.selectedSort.key,
                })
                .then((data) => {
                    if (data && data.meta && data.meta.last_page < page) {
                        this.fetch(1)
                    }
                })
        },

        saveAndFetch() {
            window.sessionStorage.setItem(
                'orders-services',
                JSON.stringify(this.selectedServices)
            )
            this.fetch()
        },

        downloadXls() {
            this.$store.dispatch('ordersExport', {
                search: this.search,
                services: this.selectedServices,
                filters: this.filters,
                sort: this.selectedSort.key,
            })
        },

        downloadXlsTablazo() {
            this.$store.dispatch('ordersExportTablazo', {
                search: this.search,
                services: this.selectedServices,
                filters: this.filters,
                sort: this.selectedSort.key,
            })
        },

        downloadXlsCustomer() {
            this.$store.dispatch('ordersExportCustomer', {
                search: this.search,
                services: this.selectedServices,
                filters: this.filters,
                sort: this.selectedSort.key,
            })
        },

        setSelection(id) {
            const idx = this.selectedCards.findIndex((el) => el == id)
            if (idx === -1) {
                this.selectedCards.push(id)
            } else {
                this.selectedCards.splice(idx, 1)
            }
        },

        selectAll() {
            if (this.selectedCards.length) this.selectedCards = []
            else {
                for (let i = 0; i < this.orders.data.length; ++i) {
                    this.selectedCards.push(this.orders.data[i].id)
                }
            }
        },

        clearSelection() {
            this.selectedCards = []
            this.selectMode = false
        },

        showOrders(ids) {
            if (this.$route.query && this.$route.query.ids == ids.join(',')) {
                return
            }
            this.$router.replace({query: { ids: ids.join(',') }})
            this.fetch()
        },
    },

    beforeRouteUpdate(to, from, next) {
        this.$store.dispatch('filterComponent', Filter)
        next()
    },
}
</script>

<template lang="pug">
    .m-4
        acrm-modal-mass-edit(ref="massModal" :services="selectedServices" :selected="selectedCards" only-selected @updated="clearSelection")
        acrm-heading(:level="4") {{ $t('ORDERS.ORDERS') }}
            small.ml-2.c-mid-5(v-if="orders.meta.total") {{ $t('ORDERS.ORDERS_TOTAL', { num: orders.meta.total }) }}
        .bg-warning.text-white(v-if="orders.order18h && orders.order18h.length")
            .px-2.py-2.d-flex.justify-content-between
                .pt-1 {{ $t('ORDERS.ALERT_18H', { num: orders.order18h.length}) }}
                acrm-input-button.block-sm-down.mt-3.mt-md-0(
                    variant="danger"
                    icon="warning"
                    @click="showOrders(orders.order18h)"
                    sm) {{ $t('ORDERS.VIEW_ORDER') }}
        .row.my-md-2.mx-n2.align-items-center
            .col-24.col-md-auto.px-2.d-flex.justify-content-between.justify-content-md-start
                acrm-input-checkbox.mr-md-3.py-2.py-md-0(v-for="service in services" :key="service.id" v-model="selectedServices[service.id]") {{ service.translated }}
            .col-12.col-md-auto.px-2.ml-auto
                acrm-input-button.block-sm-down.mt-3.mt-md-0(
                    variant="secondary"
                    icon="file_download"
                    @click="downloadXls"
                    v-if="hasRoleView('orderlist.filters.xlsx')"
                    sm link) {{ $t('ORDERS.XLSX')}}
            .col-12.col-md-auto.px-2
                acrm-input-button.block-sm-down.mt-3.mt-md-0(
                    variant="secondary"
                    icon="file_download"
                    @click="downloadXlsTablazo"
                    v-if="hasRoleView('orderlist.filters.xlsx-tablazo')"
                    sm link) {{ $t('ORDERS.XLSX_TABLAZO')}}
            .col-12.col-md-auto.px-2
                acrm-input-button.block-sm-down.mt-3.mt-md-0(
                    variant="secondary"
                    icon="file_download"
                    @click="downloadXlsCustomer"
                    v-if="hasRoleView('orderlist.filters.xlsx-customer')"
                    sm link) {{ $t('ORDERS.XLSX_CUSTOMER')}}
            .col-24.col-md-auto.px-2
                acrm-input-button.block-sm-down.mt-3.mt-md-0(
                    v-if="hasRoleUpdate('orderlist.orders')"
                    icon="add"
                    @click="$router.push({name: 'orders-create'})"
                    sm) {{ $t('ORDERS.NEW')}}
        .row.my-md-2.mx-n2.align-items-center
            .col-24.col-md-7.col-lg-7.col-xl-5.px-2(v-if="hasRoleView('orderlist.filters.date')")
                acrm-multi-select.mb-0.mt-3.mt-md-0(
                    v-model="selectedSort"
                    :options="orderSort"
                    track-by="key"
                    option-label="label")
            .col-24.col-md-auto.px-2
                input-button.block-sm-down.mt-3.mt-md-0(
                    v-if="hasRole('ordercard.collapse')"
                    v-model="cardsCollapsed"
                    variant="primary"
                    :icon="cardsCollapsed ? 'unfold_more' : 'unfold_less'"
                    toggle outline sm)
                    template(v-if="cardsCollapsed") {{$t('BASE.SHOW_MORE')}}
                    template(v-else) {{$t('BASE.SHOW_LESS')}}
            .col-auto.ml-md-auto.px-2.align-self-start.align-self-md-center(v-if="hasRoleUpdate('orderlist.orders') && hasRoleUpdate('order.fields.provider_company_id')")
                input-switch.ml-auto.mt-3.mt-md-0(v-model="selectMode") {{ $t('ORDERS.MASS_UPDATE') }}

            .col.col-md-24.px-2.align-self-start
                expand.d-flex.justify-content-end.mt-3.mt-md-0(:value="selectMode")
                    input-button.mr-2.block-sm-down(
                        :variant="allSelected ? 'success': 'primary'"
                        @click="selectAll"
                        :icon="hasSelected ? 'check_box_outline_blank' : 'check_box'"
                        sm )
                        template(v-if="allSelected") {{ $t('ORDERS.DESELECT_ALL') }}
                        template(v-else) {{ $t('ORDERS.SELECT_ALL') }}
                    input-button.block-xs.block-sm-down(
                        variant="warning"
                        @click="$refs.massModal.open()"
                        icon="edit"
                        :disabled="!selectedCards.length"
                        sm)
                        | {{ $t('ORDERS.EDIT_SELECTED') }}

        acrm-order-card(
            v-for="order in orders.data"
            :key="order.id"
            :order="order"
            :selectable="selectMode"
            :selected="selectedCards.findIndex(el => el == order.id) != -1"
            @changeSelect="setSelection"
            )
        acrm-panel.m-0(v-if="orders && orders.meta && orders.meta.last_page > 1")
            acrm-paginate(:data="orders.meta" @page="fetch" :perPage="perPage" @perPage="perPage = $event" has-per-page)
</template>
